import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { sendOrder } from "api/sendOrder";
import { useOrder } from "context/OrderContext";
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";

const CustomerOrder = () => {
  const navigate = useNavigate();
  const {
    orderReference,
    shippingAddress,
    deliveryMethod,
    comments,
    ipAddress,
  } = useOrder();
  const { emptyCart } = useCart();
  const { cartItems } = useCart();
  const totalPrice = useMemo(() => {
    const total = cartItems.reduce((acc, item) => {
      const itemPrice = item.filter.price?.Unit_Price_Discount || 0;
      return acc + itemPrice * item.quantity;
    }, 0);
    return total.toFixed(2);
  }, [cartItems]);

  const totalWeight = useMemo(() => {
    const weight = cartItems.reduce((acc, item) => {
      const itemWeight = item.filter.price?.Net_Weight || 0;
      return acc + itemWeight * item.quantity;
    }, 0);
    return weight.toFixed(2);
  }, [cartItems]);

  const handlePlaceOrder = () => {
    const newErrors = {};

    if (!shippingAddress) {
      newErrors.shippingAddress = "Delivery address is required";
    }
    if (!deliveryMethod) {
      newErrors.deliveryMethod = "Delivery method is required";
    }

    const orderData = {
      orderReference: orderReference,
      orderComment: comments,
      shipping_address: {
        City: shippingAddress.City,
        Code: parseInt(shippingAddress.Code, 10),
        Name: shippingAddress.Name,
        Address: shippingAddress.Address,
        Default: shippingAddress.Default,
        Phone_No: shippingAddress.Phone_No,
        Post_Code: shippingAddress.Post_Code,
        Customer_No: parseInt(shippingAddress.Customer_No, 10),
        Country_Region_Code: shippingAddress.Country_Region_Code,
      },
      shippingMethod: deliveryMethod,
      ip_creator: ipAddress,
      orderItems: cartItems.map((item) => ({
        filterId: item.id,
        quantity: item.quantity,
        price: item.filter.price?.Unit_Price_Discount,
      })),
    };

    sendOrder(orderData)
      .then(() => {
        emptyCart();
        navigate("/");
      })
      .catch((error) => {
        console.error("Order submission failed", error);
      });
  };

  return (
    <Box>
      <TableContainer
        sx={{
          border: "1px solid #424242",
          borderRadius: "5px",
          maxWidth: "99%",
        }}
      >
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>
                <strong>Code:</strong>
              </TableCell>
              <TableCell>{shippingAddress.Code}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <strong>Firmanavn:</strong>
              </TableCell>
              <TableCell>{shippingAddress.Name}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <strong>Leveringsmetode:</strong>:
              </TableCell>
              <TableCell>{shippingAddress.Address}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <strong>Leveringsmetode:</strong>
              </TableCell>
              <TableCell> {deliveryMethod}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <strong>I alt ex. moms:</strong>
              </TableCell>
              <TableCell>{totalPrice} ddk</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <strong>Moms:</strong>
              </TableCell>
              <TableCell>0.00 ddk</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <strong>Samlet vægt (kg.):</strong>
              </TableCell>
              <TableCell>{totalWeight}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Box marginTop={5}>
        <Button
          fullWidth
          variant="contained"
          onClick={handlePlaceOrder}
          sx={{
            width: "100%",
            height: "40px",
            backgroundColor: "#424242",
            borderRadius: "5px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexShrink: 0,
            marginTop: 2,
            "&:hover": {
              backgroundColor: "#686868",
            },
          }}
        >
          Afgiv bestilling
        </Button>
      </Box>
    </Box>
  );
};

export default CustomerOrder;
